import type { FaireProductEntity } from "../../entity_types/product";

export const p_m2dr4d3xa4: FaireProductEntity = {
  token: "p_m2dr4d3xa4",
  type: "product",
  name: "Vegan Peanut Butter Doughnuts - Pack of 2",
  brandToken: "b_7qrub4tp9v",
  brandName: "Konscious Kitchen Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/23913f44acf49c84e616aca7273201216a25d9145af0a945565fc042fb12f4c0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5e71e356933f3aed288bd84c5e72d11d9a05ffe0737aca61f803b3e1202d50d1.png",
    "https://cdn.faire.com/fastly/61134596adccdcabb7f25a47a613de8a390de5751c22f863542d30d4e96f6a63.png",
    "https://cdn.faire.com/fastly/cf9a81cd48a7e63d74ce3f3686751a5707724f38ff4e079c53d6793a9706efdd.png",
  ],
  priceDollars: 6.99,
  description:
    "Indulge in our vegan, gluten-free chocolate peanut butter doughnut—a decadent treat made with rich cocoa, creamy peanut butter, and wholesome ingredients. Perfectly sweet and guilt-free, it’s love at first bite!\n\nKey Features\n\nGluten Free\nVegan\nDairy Free\nPaleo\n7G of Protein per Doughnut\n\nIngredients:\nAlmond Flour, Organic Coconut Sugar, Organic Apple Sauce, Organic Peanut Butter, Organic Coconut Oil, Semi Sweet Chocolate (Cocoa Mass, Cocoa Butter, Brown Sugar), Unsweetened Cocoa Powder, Organic Tapioca Starch, Organic Coconut Flour, Organic Psyllium Husk, Organic Coconut Milk, Pure Vanilla Extract, Organic Coconut Oil, Himalayan Sea Salt \n\n\nShelf Life:\nRefrigerated - 4 weeks\nFrozen - 9 Months\nStays fresh when kept in a closed container\nBest enjoyed at room temperature\n\nAllergy Info:\nContains: Tree Nuts (Almonds), Peanuts\nMay contain: Other Tree Nuts ",
  tags: [],
  msrpDollars: 9.99,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:50.490Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
